import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import {
	ProductAddOnInterface,
	ProductInterface,
	QuotationInterface,
	MotorRequestInterface,
	VehicleListingInterface,
	PromoCodeInterface,
	ProductDocumentInterface,
} from "../interface/motor.interface";

@Injectable({
	providedIn: "root",
})
export class MotorDataDataService {
	private basePath: string = `${environment.url}/api/Motor/`;
  private crmBasePath: string = `${environment.crmUrl}/api/Motor/MotorQuotation/`;

	constructor(private http: HttpClient) {}

	getDetailById(id: string) {
		return this.http.get<MotorRequestInterface>(
			`${this.basePath}GetRequestInfoById/${id}`,
		);
	}

	getQuotationById(id: string) {
		return this.http.get<QuotationInterface[]>(
			`${this.basePath}GetQuotation/${id}`,
		);
	}

	getVehicleListing(limit: number, offset: number, text: string, make: string) {
		return this.http.post<VehicleListingInterface[]>(
			`${this.basePath}GetVehicleModelListing`,
			{
				limit,
				offset,
				text,
				make,
			},
		);
	}
	getNonQuoteProduct(id: string) {
		return this.http.get<ProductInterface[]>(
			`${this.basePath}GetNonQuoteProduct/${id}`,
		);
	}

	getAddOn(id: string, quotationId: string) {
		return this.http.get<ProductAddOnInterface[]>(
			`${this.basePath}GetAddOn/${id}?quotationId=${quotationId}`,
		);
	}

	applyPromoCode(id: string, code: string, totalCharge: number) {
		return this.http.post<PromoCodeInterface>(
			`${this.basePath}PromoCode/${id}`,
			{
				code,
				totalCharge,
			},
		);
	}

	editRequest(id: string, val: any) {
		return this.http.post<void>(`${this.basePath}EditRequest/${id}`, val);
	}

	getProductDocumentById(id: string, language: string, insuranceType: string) {
		return this.http.get<ProductDocumentInterface[]>(
			`${this.basePath}GetProductDocument?id=${id}&language=${language}&insuranceType=${insuranceType}`,
		);
	}

	generatePayment(id: string, val: any) {
		return this.http.post<{ id: string }>(
			`${this.basePath}GeneratePayment/${id}`,
			val,
		);
	}

	generateTopupPayment(id: string) {
		return this.http.get<{ id: string }>(
			`${this.basePath}GenerateTopUpPayment/${id}`,
		);
	}

	getPaymentById(id: string) {
		return this.http.get<{
			provider: "IPay88" | "PayWithSplit" | "Razer";
			data: string;
		}>(`${this.basePath}GetPayment/${id}`);
	}

	checkPayment(refNo: string) {
		return this.http.get<{ status: boolean; data: any; amount: number }>(
			`${this.basePath}CheckPayment?refNo=${refNo}`,
		);
	}

	uploadPhoto(id: string, file: any) {
		return this.http.post<{ id: string }>(
			`${this.basePath}UploadPolicyPhotos/${id}`,
			file,
		);
	}

	deletePolicyPhoto(id: string) {
		return this.http.get(`${this.basePath}DeletePolicyPhoto/${id}`);
	  }
	  
	getPolicyPhotos(id: string, includeBase64InsteadOfUrl?: boolean) {
		let path = `${this.basePath}GetPolicyPhotos/${id}`;
		if (includeBase64InsteadOfUrl) {
		path += '?includeBase64InsteadOfUrl=true';
		}

		return this.http.get(path);
	}

	getPolicyTopUpDetail(id: string) {
		return this.http.get(`${this.basePath}GetPolicyTopUpDetail/${id}`);
	}

	editCarVariant(linkId: string, vehicleId: string) {
		return this.http.post<any>(`${this.basePath}EditCarVariant/${linkId}?vehicleId=${vehicleId}`, null);
	}

	getChubbQuotationPricing(
		id: string, 
		selectedAddOns: any[], 
		windshieldSI: number,
		selectedAvailableInsurerCarPlus: string
	) {
		return this.http.post(`${this.crmBasePath}GetChubbQuotationPricing/${id}`, {
			selectedAddOns, 
			windshieldSI,
			selectedAvailableInsurerCarPlus
		})
	}

  getGeneraliQuotationPricing(id: string, selectedAddOns: any[], addDriversInfo: any[], windshieldSI: number, gcktSI: number, cartDays: number, cartDailyCoverage: number){
    return this.http.post(`${this.crmBasePath}GetGeneraliQuotationPricing/${id}`, {selectedAddOns, addDriversInfo, windshieldSI, gcktSI, cartDays, cartDailyCoverage})
  }

	getZurichQuotationPricing(
		id: string,
		selectedAddOns: any[],
		addDriversInfo: any[],
		windshieldSI: number,
		address1: string,
		address2: string,
		city: string,
		isHirePurchase: boolean,
		loanCompanyName: string,
		hirePurchaseEffDate: string | null
	) {
		return this.http.post(`${this.crmBasePath}GetZurichQuotationPricing/${id}`, {
			SelectedAddOns: selectedAddOns,
			AdditionalDriversInfo: addDriversInfo,
			WindshieldSI: windshieldSI,
			Address1: address1,
			Address2: address2,
			City: city,
			IsHirePurchase: isHirePurchase,
			LoanCompanyName: loanCompanyName,
			HirePurchaseEffDate: hirePurchaseEffDate
		})
	}

	getTMIMQuotationPricing(id: string, selectedAddOns: any[], windshieldSI: number, driverCount: number, isHirePurchase: boolean, loanComName: string) {
    const requestData = {
      QuotationId: id,
      SelectedAddon: selectedAddOns,
      windscreenValue: windshieldSI,
      DriverCount: driverCount,
			IsHirePurchase: isHirePurchase,
			LoanComName: loanComName
    };
		
    return this.http.post(`${this.crmBasePath}GetTMIMFinalPrem`, requestData);
  }

	processGeneraliOrder(quotationId: string, infoValue: any){
		return this.http.post(`${this.crmBasePath}GeneraliGetOrder/${quotationId}`, infoValue);
	}

	processChubbOrder(quotationId: string, infoValue: any){
		return this.http.post(`${this.crmBasePath}ChubbGenQuotation/${quotationId}`, infoValue);
	}

	getCARTAddOnPriceList() {
    return this.http.get(`${this.basePath}GetCARTAddOnPriceList`);
  }

  getAllianzQuotationPricing(
    quotationId: string, 
    selectedAddOns: any[],
    windshieldSI: number,
    cartDays: number,
    cartAmount: number,
    gcktSI: number,
    additionalDriverInfo: any[]) {
    return this.http.post(
      `${this.crmBasePath}GetAllianzQuotationPricing/${quotationId}`,
      {
        selectedAddOns,
        windshieldSI,
        cartDays,
        cartAmount,
        gcktSI,
        additionalDriverInfo
      }
    );
  }

  checkAllianzPremiumsBeforePayment(
    quotationId: string, 
    selectedAddOns: any[],
    windshieldSI: number,
    cartDays: number,
    cartAmount: number,
    gcktSI: number,
    additionalDriverInfo: any[]) {
    return this.http.post(`${this.crmBasePath}CheckAllianzE2EPremiumsBeforePayment/${quotationId}`, 
      {
        selectedAddOns,
        windshieldSI,
        cartDays,
        cartAmount,
        gcktSI,
        additionalDriverInfo
      }
    );
  }

  checkAllianzE2EQuotationValidity(quotationId: string){
    return this.http.get<boolean>(`${this.crmBasePath}CheckAllianzE2EQuotationValidity/${quotationId}`);
  }
}
